import './GlobalStyles.scss'
import './grid.css'
import './reset.css'
import './index.scss'

function GlobalStyles({children}) {
    return children
}

export default GlobalStyles
